function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clsLogout-1{fill:#47aaa1;opacity:0.2;}.clsLogout-2{fill:#48a9a1;}.clsLogout-3{fill:none;stroke:#555150;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Ikonka_logowania",
  "data-name": "Ikonka logowania"
}, /*#__PURE__*/React.createElement("rect", {
  className: "clsLogout-1",
  x: 8.21,
  y: 1.52,
  width: 11.3,
  height: 17.4,
  rx: 0.75
}), /*#__PURE__*/React.createElement("path", {
  className: "clsLogout-2",
  d: "M14.28,10.76l-3.89-3.2a.75.75,0,0,0-1,1.16l2.27,1.87H2.63a.75.75,0,1,0,0,1.5h9.08L9.44,14a.75.75,0,0,0,.48,1.33.72.72,0,0,0,.47-.17l3.89-3.2a.75.75,0,0,0,.27-.58A.78.78,0,0,0,14.28,10.76Z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "clsLogout-3",
  points: "6.81 7.89 6.81 3.39 16.61 3.39 16.61 19.29 6.81 19.29 6.81 14.79"
}));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logout.3f272436.svg";
export { ForwardRef as ReactComponent };